import { useContext } from 'react';
import { EventBusContext } from './EventBusProvider';

/**
 * useEventBus — returns the emit function. Throws if used outside provider so
 * misuse is loud, not silently dropped.
 */
export function useEventBus() {
  const emit = useContext(EventBusContext);
  if (!emit) throw new Error('useEventBus must be used within <EventBusProvider>');
  return emit;
}
